import React, { useEffect, useRef, useState } from "react";
import {
  RootContainer,
  Heading,
  NavContainer,
  ArrowIconWrapper,
  // Logo,
  Title,
  ContentContainer,
  ContinueButton,
  Logo,
} from '../AuthStack.style';
import {
  StyledInput,
  TimeText,
  BottomBox,
  // SubTitle,
} from "./OtpVerify.style";
import { Spin } from "antd";
import OtpInput from "react-otp-input";
import { api } from "@api";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { saveToken, saveUser } from "@redux/auth/authSlice";
import { openAlert } from "@redux/app/appSlice";
import { localStorage, getFingerprintData } from "@utils";
import { useDispatch, useSelector } from "react-redux";
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import { REGISTER_MODE_SK, LOGIN_MODE_SK, RESET_MODE_SK, SHARE_TYPES } from "@constants";
import moment from "moment/moment";
import "moment-duration-format";
import { Alert } from "@components";
import { useTranslation } from "react-i18next";
import { clearInterval, setInterval } from 'worker-timers';
import { AuthBackIcon } from "@assets";

const CODE_LENGTH = 6;

const OtpVerify = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { type } = useParams();
  const { state } = useLocation();
  const { otp_expired_time } = useSelector((state) => state.app.settings);
  const [code, setCode] = useState("");
  const [required, setRequired] = useState(false);
  const [loading, setLoading] = useState(false);
  const [expired_time, setExpiredTime] = useState("");
  const [resendLoading, setResendLoading] = useState(false);
  const timer = useRef();
  const [disableButton, setDisableButton] = useState(true);

  // Disable Login button when otp input is empty
  useEffect(() => {
    setDisableButton(code.length !== CODE_LENGTH);

  }, [code]);

  useEffect(() => {
    otp_expired_time && setTimer(otp_expired_time);

    return () => {
      clearInterval(timer.current);
    };
    // eslint-disable-next-line
  }, [otp_expired_time]);

  const setTimer = ({ num, unit }) => {
    var duration = moment.duration(num, unit).asMilliseconds();
    var interval = 1000;

    timer.current = setInterval(function () {
      duration = moment.duration(duration - interval, "milliseconds");
      if (duration.seconds() >= 0 && duration.minutes() >= 0) {
        setExpiredTime(duration.format("mm:ss", { trim: false }));
      }
    }, interval);
  };

  const onSubmit = () => {
    if (!loading) {
      if (!code || code.length < CODE_LENGTH) {
        setRequired(true);
        return;
      }
      setRequired(false);
      setLoading(true);
      getFingerprintData()
        .then(device_info => {
          api
            .verifyOtp({
              phone: state.phone,
              code,
              type,
              device_info,
            })
            .then((response) => {
              setLoading(false);
              if (type === REGISTER_MODE_SK) {
                handleRegisterSuccess(response);
              }
              showAlert({
                message: t("auth.otpVerifySuccessMessage"),
                successCallback: () => successCallback(state.phone, response?.can_share),
              });
            })
            .catch((errorMsg) => {
              setLoading(false);
              showAlert({
                message: errorMsg,
                isError: true,
              });
            });
        })
        .catch(() => { });
    }
  };

  const successCallback = (phone, can_share) => {
    if (type === REGISTER_MODE_SK) {
      if (can_share) {
        navigate(`/${PRIVATE_ROUTE.SHARE}`, {
          state: {
            share_type: SHARE_TYPES.REGISTER,
          },
        });
        return;
      }
      navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);

    } else if (type === LOGIN_MODE_SK) {
      navigate(`/${PUBLIC_ROUTE.PASSWORD_LOGIN}`, {
        state: phone,
      });

    } else if (type === RESET_MODE_SK) {
      navigate(`/${PUBLIC_ROUTE.RESET_PASSWORD}`, {
        state: phone,
      });

    } else {
      return;
    }
  };

  const handleRegisterSuccess = (response) => {
    if (response) {
      const { token, ...user } = response.user || {};
      // save token and user to redux
      dispatch(saveToken(token));
      dispatch(saveUser(user));

      // save token and user to localstorage
      localStorage.setToken(token);
      localStorage.setUser(user);

      // set token to request obj
      api.setSessionToken(token);
    }
  };

  const resendRegister = () => {
    api
      .register(state)
      .then(() => {
        messageResent();
      })
      .catch((errorMsg) => {
        messageResentError(errorMsg);
      });
  };

  const resendLogin = () => {
    api
      .prelogin(state)
      .then(() => {
        messageResent();
      })
      .catch((errorMsg) => {
        messageResentError(errorMsg);
      });
  };

  const resendForgotPassword = () => {
    api
      .forgotPassword(state)
      .then(() => {
        messageResent();
      })
      .catch((errorMsg) => {
        messageResentError(errorMsg);
      });
  };

  const resendCode = () => {
    if (!resendLoading) {
      setResendLoading(true);
      setCode('');
      switch (type) {
        case REGISTER_MODE_SK:
          resendRegister();
          break;
        case LOGIN_MODE_SK:
          resendLogin();
          break;
        case RESET_MODE_SK:
          resendForgotPassword();
          break;
        default:
          break;
      }
    }
  };

  const messageResent = () => {
    setResendLoading(false);
    showAlert({
      message: t("auth.otpResentCode"),
    });
    clearInterval(timer.current);
    setTimer(otp_expired_time);
  };

  const messageResentError = (errorMsg) => {
    setResendLoading(false);
    showAlert({
      message: errorMsg,
      isError: true,
    });
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goBack = () => {
    navigate(-1);
  };

  if (!state) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />;
  }

  return (
    <>
      <RootContainer>
        <Heading>
          <NavContainer>
            <ArrowIconWrapper onClick={goBack}>
              <AuthBackIcon />
            </ArrowIconWrapper>
          </NavContainer>
          <Logo />
        </Heading>

        <ContentContainer>
          <Title>{t("auth.otpEnterPhone")}</Title>
          {/* {type === "reset" && <SubTitle > {t("auth.otpResetMessage")}  </SubTitle>} */}
          <OtpInput
            value={code}
            onChange={setCode}
            numInputs={CODE_LENGTH}
            inputType="number"
            renderInput={(props, index) => (
              <StyledInput
                status={required ? "error" : "default"}
                autoFocus={index === 0}
                {...props}
              />
            )}
            containerStyle="otp-length-6"
          />

          <BottomBox>
            {
              expired_time !== '00:00' ? (
                <TimeText>{expired_time}</TimeText>
              ) : (
                <TimeText
                  onClick={() => { expired_time === '00:00' && resendCode() }}
                  disabled={expired_time !== '00:00'}
                >
                  {resendLoading ? <Spin size="small" /> : t("auth.otpResendCode")}
                </TimeText>
              )
            }
          </BottomBox>

          <ContinueButton
            type="primary"
            size="large"
            loading={loading}
            onClick={onSubmit}
            disabled={disableButton}
            style={{ margin: "16px 0 0" }}
          >
            {t("common.continue")}
          </ContinueButton>
        </ContentContainer>


      </RootContainer>
      <Alert />
    </>
  );
};

export default OtpVerify;
